import { Box } from "@mui/material";
import { PageTitle } from "components/PageTitle";
// import { GetData } from "contexts/DataContext";

import React from "react";
import { AvatarField } from "./ProfileField";
import ProfileMenu from "./ProfileMenu";

export function SettingsBody(props) {
  // const { dataObj } = GetData();

  return (
    <React.Fragment>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          height: "100%",
        }}
      >
        <PageTitle home={true} title="Настройки" />
        <Box
          sx={{
            alignSelf: "center",
            display: "flex",
            flexDirection: "column",
            gap: "0px",
            maxWidth: "820px",
            overflow: "auto",
            padding: "0.4rem",
            position: "relative",
            width: "100%",
          }}
        >
          <AvatarField />
          <ProfileMenu />
          {/* <TypeField /> */}
          {/* <CameraField /> */}
          {/* <EquipmentField /> */}
          {/* <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  gap: "12px",
                  width: "100%",
                }}
              >
                <RateField />
                <ZoomField />
              </Box> */}
          {/* <DelayField /> */}
          {/* <OrderField /> */}
          {/* <ChannelField /> */}
        </Box>
      </Box>
    </React.Fragment>
  );
}
